module.exports = __webpack_public_path__ + "img/sanzu river.0d6fcca0.png";